export const FlashSalesSkeleton = () => {
  return (
    <section className="product padding-top padding-bottom section-bg">
      <div className="container">
        {/* Skeleton for the header */}
        <div className="section-header">
          <div
            className="placeholder "
            style={{ width: '250px', height: '40px' }}
          >
            <span className="placeholder w-100 h-100"></span>
          </div>
          <div
            className="placeholder "
            style={{ width: '100px', height: '40px' }}
          >
            <span className="placeholder w-100 h-100"></span>
          </div>
        </div>
        {/* Skeleton for the product cards */}
        <div className="d-flex gap-3 overflow-hidden">
          {[...Array(4)].map((_, i) => (
            <div
              key={i}
              className="card placeholder "
              style={{ minWidth: '270px', border: 'none' }}
            >
              <div
                className="placeholder"
                style={{ height: '230px', width: '100%' }}
              ></div>
              <div className="card-body">
                <span className="placeholder col-8 me-2"></span>
                <span className="placeholder col-5 mt-2 me-2"></span>
                <span className="placeholder col-6 mt-3"></span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
